export const createDOMelements = () => {
    const zIndex = 9999998

    // IFRAME
    const iframe = document.createElement('iframe')
    iframe.style.position = 'relative'
    iframe.style.width = '100%'
    iframe.style.height = '100%'
    iframe.style.border = 'none'
    iframe.style.zIndex = '2'
    iframe.allowFullscreen = true

    // CONTROL BTN
    const controlBtn = document.createElement('g-btn')
    controlBtn.draggable = false
    controlBtn.style.height = '40px'
    controlBtn.style.width = SDK_MODE ? '25px' : '40px'
    controlBtn.style.padding = '0'
    controlBtn.style.position = 'absolute'
    controlBtn.style.zIndex = '1'
    controlBtn.style.left = SDK_MODE ? '-25px' : '-40px'
    controlBtn.style.bottom = '20vh'
    controlBtn.style.alignItems = 'center'
    controlBtn.style.justifyContent = 'center'
    controlBtn.style.transform = 'translateX(0%)'
    controlBtn.style.transition = 'transform linear 0.3s'
    controlBtn.style.background = 'unset'
    controlBtn.style.border = 'none'
    controlBtn.style.cursor = 'pointer'

    // We need a 'wrapper' in order to attach button to iframe and fix css issues with transition while resizing
    const container = document.createElement(
        `guidde-${EXT_MODE ? 'ext' : 'sdk'}`
    )
    container.id = `guidde-${EXT_MODE ? 'ext' : 'sdk'}`
    container.style.zIndex = String(zIndex)
    container.style.transform = 'translateX(100%)'
    container.style.position = 'fixed'
    container.style.bottom = '0'
    container.style.right = '0'
    container.style.height = '100vh'
    container.style.transition = 'transform linear 0.3s'
    container.style.boxShadow = '-4px -1px 20px 0 rgb(0 0 0 / 10%)'

    const overlay = document.createElement('overlay')
    overlay.style.zIndex = String(zIndex - 1)
    overlay.style.position = 'fixed'
    overlay.style.top = '0'
    overlay.style.width = '100vw'
    overlay.style.height = '100vh'
    overlay.style.backgroundColor = 'rgba(42,42,42,0.5)'
    overlay.style.display = 'none'

    container.appendChild(controlBtn)
    container.appendChild(iframe)

    if (EXT_MODE) {
        // Media query for 1280px break point
        const changeIframeStyle = e => {
            container.style.width = 'max(650px, 35vw)'
            if (e.matches) container.style.width = 'max(650px, 35vw)'
            else container.style.width = '85vw'
        }

        const media = window.matchMedia('(min-width: 1280px)')
        changeIframeStyle(media)
        media.addListener(changeIframeStyle)
    }

    return { container, iframe, controlBtn, overlay }
}
